import stylesColors from 'common/styles/styles.colors';
import { themedStyled } from 'common/styles/styletron.theme';
import { StyleObject } from 'styletron-standard';

export const styles: {
  [key: string]: StyleObject | any;
} = {
  tabPanel: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
    height: '100%',
    padding: '24px 0px 0px 0px !important',
  },
  tab: {
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '200px',
    flexGrow: 1,
    height: '100%',
  },
  tabList: {
    minHeight: '41.48px',
  },
  tabBorder: {
    height: '3px',
  },
  tabHighlight: {
    height: '3px',
    bottom: '2px',
    backgroundColor: stylesColors.primaryDefault,
  },
};

export const TabHeaderContainer = themedStyled('div', {
  position: 'relative',
  margin: '-16px',
  padding: '16px',
});
